module.exports = __webpack_public_path__ + "static/media/Bull.ae038632.png";